import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService<T> {
  public setItem(key: string, value: Partial<T>) {
    if (this.hasLocalStorage()) {
      const oldValue = this.getItem(key);
      const newValue = Object.assign({}, oldValue, value);
      const valueString = JSON.stringify(newValue);
      localStorage.setItem(key, valueString);
    }
  }

  public getItem(key: string): T {
    if (this.hasLocalStorage()) {
      const valueString = localStorage.getItem(key);
      return JSON.parse(valueString);
    }
  }

  public removeItem(key: string): void {
    if (this.hasLocalStorage()) {
      localStorage.removeItem(key);
    }
  }

  private hasLocalStorage() {
    return !!window.localStorage;
  }
}
